import { useParams, Link } from 'react-router-dom'
import { ArrowLeft } from 'lucide-react'
import { useBenefitRule } from '@/modules/benefits/hooks/useBenefitRule'
import { useBenefitRuleMutation } from '@/modules/benefits/hooks/useBenefitRuleMutation'
import { BenefitRuleForm } from '@/modules/benefits/components/BenefitRuleForm'
import {
  extractTriggerData,
  extractActionData,
  extractRulesData,
} from '@/modules/benefits/types'
import { ErrorState } from '@/shared/components/ui/atoms/ErrorState'

export function BenefitRuleEditPage() {
  const { id } = useParams<{ id: string }>()
  const ruleId = Number(id)
  const { data: rule, isLoading, error: loadError } = useBenefitRule(ruleId)
  const { update, isSubmitting, error: mutationError } = useBenefitRuleMutation()

  if (isLoading) {
    return <div className="animate-pulse h-96 bg-gray-100 rounded-lg" />
  }

  if (loadError) {
    return <ErrorState message={loadError} />
  }

  if (!rule) return null

  return (
    <div>
      <div className="flex items-center gap-3 mb-6">
        <Link to="/benefits" className="text-gray-500 hover:text-gray-700">
          <ArrowLeft size={20} />
        </Link>
        <h1 className="text-2xl font-bold text-gray-900">Editar Regla de Beneficio</h1>
      </div>
      <div className="card p-6">
        <BenefitRuleForm
          defaultTriggerValues={extractTriggerData(rule)}
          defaultActionValues={extractActionData(rule)}
          defaultRulesValues={extractRulesData(rule)}
          onSubmit={(payload) => update(ruleId, payload)}
          isSubmitting={isSubmitting}
          submitLabel="Guardar cambios"
          error={mutationError}
        />
      </div>
    </div>
  )
}
